<template>
<div class="webCart">

    <button @click="openCart" id="showCart" class="cartTrigger">
        <img src="/images/ui/ui_collection-view.png" alt="View Collection">
        <div v-if="cartCount > 0" class="collection-count">
            {{ cartCount }}
        </div>
    </button>

    <transition name="slide" appear>
        <div class="cart-wrapper" v-if="visible">
            <div class="cart-body">
                <div class="collection-head">
                    <button class="close-collection" @click="closeCart">
                        <img src="/images/ui/ui_close.png" alt="Close Collection View">
                    </button>
                    <p class="collection-title">Your Collection</p>
                    <div class="button-spacer">
                        <button v-if="!emptyCarted" class="share-collection" @click="shareCollection">
                            <img src="/images/ui/ui_collection-email.png" alt="Share Collection via Email">
                        </button>
                    </div>
                </div>

                <p v-if="emptyCarted" class="empty-message">You haven't collected any items yet. Explore the 3D gates (Yellow,
                    Blue, and Green) and click around to see what you find...</p>

                <div v-else class="collected-items">
                    <div class="collected-item" v-for="(item, index) in inCart" :key="index">
                        <div class="item-info">
                            <div>
                                <img class="collected-item-image" :src="item.image" :alt="item.name" />
                            </div>
                            <a :href="inCart[index].link" target="_blank">
                                <p>{{ item.name }}</p>
                            </a>
                        </div>
                        <button @click="removeItem(index)">
                            <img src="/images/ui/ui_collection-remove.png" alt="Remove from Collection">
                        </button>
                    </div>
                </div>

                <div class="total-collected">
                    <p>You have discovered {{discoveredCount}} of the {{collectablesCount}} pieces to find.</p>
                    <CollectablePie v-bind:pieSlice="pieData" />
                </div>
            </div>
        </div>
    </transition>

    <InfoPop v-if="displayInfoPop" v-bind:popText="interfacePopText" v-bind:isTopLeft="true" @button="interactedInfoPop"/>

</div>
</template>

<script>
import {
    getCartContents
} from "@/store/index.js"

import CollectablePie from "@/components/CollectablePie";
import InfoPop from '@/components/InfoPop'
import {
    bus
} from "@/main";

export default {
    name: "WebCart",
    components: {
        CollectablePie,
        InfoPop
    },
    data() {
        return {
            firstTimeOpened: false,
            visible: false,
            latestCount: Number,
            emptyCarted: false,
            pieData: [{
                    color: "#EEEEEE",
                    value: 0
                },
                {
                    color: "#074F57",
                    value: 0
                },
                {
                    color: "#EEEEEE",
                    value: 0
                },
            ],
            interfacePopText: 'Explore 3D gates and collect artefacts into your inventory, find out more.',
            disabledInfoPop: false,
            hoverSound: null,
            hoverPath: [
              '/audio/UI/hover/UI_hover1.mp3',
              '/audio/UI/hover/UI_hover2.mp3',
              '/audio/UI/hover/UI_hover3.mp3',
              '/audio/UI/hover/UI_hover4.mp3',
            ],
            hoverPlaying: false,

        }
    },
    computed: {
        collectables() {
            return this.$store.getters.collectables;
        },
        collectablesCount() {
            return this.collectables.length;
        },

        WebCart() {
            return this.$store.getters.WebCart;
        },
        cartCount() {
            return this.WebCart.length;
        },
        inCart() {
            return getCartContents()
        },

        discovered() {
            return this.$store.getters.discovered;
        },

        discoveredCount() {
            return this.discovered.length;
        },

        displayInfoPop(){
            return this.$route.name === 'Explore' && !this.disabledInfoPop
        },



    },
    methods: {

        updatePie() {
            console.log("discovered " + this.discoveredCount)
            let currentlyCollectedPercentage = (this.discoveredCount / this.collectablesCount) * 100
            this.pieData[1].value = currentlyCollectedPercentage
            this.pieData[2].value = 100 - currentlyCollectedPercentage
        },

        removeItem(index) {
            this.$store.dispatch("removeItem", index);
            if (this.cartCount < 1) this.closeCart()
        },

        openCart() {
            if (!this.firstTimeOpened) {
                bus.$on('closeCart', this.closeCart);
                this.firstTimeOpened = true
            }
            this.emptyCarted = this.cartCount < 1;
            this.visible = true
        },

        shareCollection() {
            const baseUrl = "https://greenhamwomen.digital"
            const subject = "Look what I've found on Greenham Women Digital!";
            let body = "I've just been exploring " + baseUrl + ", which is a website about Greenham Common Peace Camp!";
            body += "\n\n" + "I would like to share a few artefacts I've found, you can explore more on your own:" + "\n\n"
            getCartContents().forEach(collected => {
                let fullUrl = baseUrl + collected.link
                body += fullUrl
                body += "\n\n"
                //console.log(collected.link)
            })
            body += "Over to you!"
            let uri = "mailto:?subject=";
            uri += encodeURIComponent(subject);
            uri += "&body=";
            uri += encodeURIComponent(body);
            window.open(uri);
        },

        closeCart() {
            this.visible = false
        },

        printCartItems() {
            return this.$store.getters.WebCart.map(cartitems => {
                return this.$store.getters.collectables.find(items => {
                    return cartitems === items.id;
                });
            })
        },
      interactedInfoPop(){
        this.disabledInfoPop = true
      },

      playRandomSound() {
        if (this.hoverPlaying) return;
        this.hoverPlaying = true
        let tempRange = Math.floor(Math.random() * this.hoverPath.length)
        this.hoverSound = new Audio()
        this.hoverSound.src = this.hoverPath[tempRange]
        this.hoverSound.play()
        setTimeout(this.renableAudio.bind(this), 1500);
      },
      renableAudio() {
        this.hoverPlaying = false
        this.hoverSound = null
      },
    },


    mounted() {
      document.querySelector('.cartTrigger').addEventListener('mouseover', this.playRandomSound.bind(this))



    },

    beforeDestroy() {
        bus.$off('closeCart')
        //bus.$off('toggleEmpty')
    },

    beforeUpdate() {
        if (this.latestCount !== this.discoveredCount) {
            this.latestCount = this.discoveredCount
            this.updatePie()
        }
        if (this.cartCount < 1) {
            this.emptyCarted = true

        } else if (this.cartCount === 1) {
            this.emptyCarted = false
        }
    }
}
</script>

<style scoped>
.webCart {
    position: fixed;
    z-index: 98;
    pointer-events: auto;
}

button#showCart {
    position: fixed;
}

button.close-collection {
    /* margin: .35em 0 0 .35em; */
}

button#showCart,
button.close-collection {
    top: .35em;
    left: .35em;
    height: 50px;
    width: 50px;
    display: inline;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    cursor: pointer;
    outline: inherit;
    width: 57px;
    height: 57px;
    line-height: 1.15;
    padding: 0;
    pointer-events: auto;
}

#showCart img,
button.close-collection img {
    padding: 0;
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: block;
}

.collection-count {
    border-radius: 50%;
    height: 1.25em;
    width: 1.25em;
    background-color: #FF3B40;
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: .75em;
    color: white;
}

.cart-wrapper {
    position: fixed;
    align-content: center;
    left: 0;
    top: 0;
    width: 18em;
    max-height: 100vh;
    overflow-y: scroll;
    background-color: var(--modal-back);
    border-radius: 0 0 .5em .5em;
    border-right: 1px solid var(--darkest);
    border-bottom: 1px solid var(--darkest);
    max-width: 100vw;
}

.cart-body {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.collection-head {
    display: flex;
    align-items: center;
    margin: .35em 0 0 .35em;
    justify-content: space-between;
}

.collection-title {
    font-family: 'Tauri', 'ElaineSans-Bold', sans-serif;
    display: inline;
    margin: 0;
    padding-left: .65em;
}

.collected-items {
    margin: 1em 0;
}

.collected-item,
.total-collected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .75em;
}

.total-collected {
    padding: 0 1em;
}

.total-collected p {
    flex: 0 2 auto;
}

.item-info {
    display: flex;
    align-items: center;
}

.collected-item p {
    padding-left: .5em;
}

.collected-item img.collected-item-image {
    display: block;
    height: 57px;
    width: 57px;
    padding: .25em;
}

.collected-item button,
.share-collection {
    display: block;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    outline: inherit;
    width: 57px;
    height: 57px;
    line-height: 1.15;
    padding: 0;
    margin: 0;
}

.collected-item button img,
.share-collection img {
    padding: 0;
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: block;
}

.share-collection {
    margin: 0 .7em 0 0;
}

.button-spacer {
    min-width: 45px;
}

.empty-message {
    padding: 0 1em;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform .5s;
}

.slide-enter,
.slide-leave-to {
    transform: translateY(-100%);
}

@media screen and (min-width: 660px) {
    .cart-wrapper {
        border-radius: 0 0 .5em 0;
    }
}
</style>
